import { render, staticRenderFns } from "./aboutpage.vue?vue&type=template&id=33e8bcde"
import script from "./aboutpage.vue?vue&type=script&lang=js"
export * from "./aboutpage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports